export enum ApprovalStatus {
  APPROVED = 0,
  REJECTED,
  PENDING,
  NOT_ARRIVED,
}

export const ApprovalStatusMap = {
  [ApprovalStatus.APPROVED]: '通过',
  [ApprovalStatus.REJECTED]: '驳回',
  [ApprovalStatus.PENDING]: '待审批',
  [ApprovalStatus.NOT_ARRIVED]: '未到达',
};

export const ApprovalStatusColorMap = {
  [ApprovalStatus.APPROVED]: 'success',
  [ApprovalStatus.REJECTED]: 'error',
  [ApprovalStatus.PENDING]: 'default',
  [ApprovalStatus.NOT_ARRIVED]: 'default',
};
